export const CARD_TYPE = {
	JOB_INFORMATION: "JobInformation",
	CARTON_INFORMATION: "CartonInformation",
	LABEL_INFORMATION: "LabelInformation",
	DIM_PRODUCT: "DimProduct",
} as const;
